import { css } from '@emotion/css';
import { UsageTrackerEvent, usageTracker } from '@volumental/analytic';
import {
  BoxContainer,
  DisabledStar,
  StarRating,
  TextButton,
} from '@volumental/common';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  useInputStore,
  usePersistedViewStore,
  useScannerStore,
  useSessionStore,
} from '../../../store';

const titleStyle = css`
  font-size: 16px;
  text-align: center;
`;
const boldTitleStyle = css`
  ${titleStyle}
  font-weight: bold;
  margin-bottom: 16px;
`;
const ratingStyle = css`
  display: flex;
  justify-content: center;
  padding-top: 16px;
`;

interface NpsBoxProps {
  onShowModal: () => void;
}

export function NpsBox({ onShowModal }: NpsBoxProps) {
  const { mode, productID } = useSessionStore((store) => store);
  const { t } = useTranslation();
  const [rating, setRating] = useState(0);
  const [submited, setSubmited] = useState(false);
  const { setNpsScoreHasBeenSet, npsScoreHasBeenSet } = usePersistedViewStore(
    (store) => store,
  );

  const { flowType } = useScannerStore((store) => store);
  const { scanID, previousPurchaseID } = useInputStore((store) => store);

  const onSetRating = (userRating: number): void => {
    setRating(userRating);
    const feedback: Record<string, string | undefined> = {
      Rating: userRating.toString(),
      productID: productID ?? 'UNKNOWN',
      sizing_flow_type: flowType ?? 'UNKNOWN',
      previous_purchase_id: previousPurchaseID ?? 'NO ID',
      scanID: scanID ?? 'NO ID',
      experience: mode,
    };
    usageTracker.track(UsageTrackerEvent.SizeChartNPS, feedback);
    setTimeout(() => {
      setSubmited(true);
      setNpsScoreHasBeenSet(true);
    }, 1000);
  };
  if (npsScoreHasBeenSet && !submited) {
    return undefined;
  }
  return submited ? (
    <BoxContainer
      padding="20px"
      marginBottom="20px"
      marginTop="24px"
      alignItems="center"
    >
      <div className={boldTitleStyle}>
        {t('feedbackModal.thanksForFeedback')}
      </div>
      <DisabledStar rate={rating} altText={t('imageAlt.starIcon')} />
      <TextButton onClick={onShowModal} style={{ margin: '10px 0px' }}>
        <div className={titleStyle}>
          {t('feedbackModal.tellMoreButtonTitle')}
        </div>
      </TextButton>
    </BoxContainer>
  ) : (
    <BoxContainer
      padding="20px"
      marginBottom="20px"
      marginTop="24px"
      alignItems="center"
    >
      <div className={titleStyle}>
        <Trans>{t('feedbackModal.sizeChartNPSTitle')}</Trans>
      </div>
      <div className={ratingStyle}>
        <StarRating
          disableOnTap
          onRatingSelect={onSetRating}
          altImage={t('imageAlt.starIcon')}
          lowHighLabel={{
            low: t('feedbackModal.npsLowLabel'),
            high: t('feedbackModal.npsHighLabel'),
          }}
        />
      </div>
    </BoxContainer>
  );
}
